import React from "react";

import { ThemeChooserBlock } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import themes from "../../styles/themes.module.scss";
import styles from "./themable.module.scss";

/**
 * Get the classname to theme an element. Useful when theming things that are not
 * at the base level of a page or are already full-bleed
 */
export const getThemeClass = (
    themeName: ThemeChooserBlock | null | undefined,
) => {
    if (!themeName || themeName === "inherit") return undefined;
    return themes[themeName];
};

export const ThemedModule = ({
    theme,
    children,
}: React.PropsWithChildren<{
    theme: ThemeChooserBlock | null | undefined;
}>) => (
    <div
        className={concatClassNames([
            styles.themableModule,
            getThemeClass(theme),
        ])}
    >
        {children}
    </div>
);
